export const environment = {
  production: false,
  url: "https://crl-gateway-sit.api-nonprd.allianz.co.id/eform/",
  partnerIdBSI: '6736394',
  partnerIdBTPN: '6187346',
  randomNonce: 'nonce-WC8WhtyB2Xdk3kQqef55OA==',
};
